/**
 * ReviewDetailPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  InputFormTable,
  ModalLayout,
  Text,
} from 'components';
import {
  Input,
  Button,
  Rate,
  Avatar,
  Radio,
  Descriptions,
  Space,
  Select,
  Switch,
  Spin,
  Divider,
  Flex,
  Image,
  InputNumber,
} from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { STORE_URL, stringToMoneyFormat } from 'utils';
import moment from 'moment';
import {
  // PAYMENT_METHOD_CONSTANT, // 주문 유형
  // PAYMENT_STATUS_CONSTANT, // 주문의 결제상태
  PRODUCT_TYPE, // 상품유형
  PACKAGING_METHOD, // 포장방식
  // PRODUCT_STATUS, //상품 판매 상태
  // APPLICATION_STATUS, // 상품 등록 승인여부
  // TAX_TYPE, // 과세유형
} from 'constants/ProductConstants';

/**----------------------------------------
 * [Component] 총관리자: 리뷰상세 - Presenter
 * ----------------------------------------
 */
const ReviewDetailPresenter = (props) => {
  /* ===== PROPS ===== */
  const {
    loading,
    isOpened,
    setIsOpened,
    review,
    onUpdateReview,
    onDeleteReview,
    onReserveReview,
    onGetReview,
    permission,
  } = props;

  /* ===== STATE ===== */
  const [answer, setAnswer] = useState(
    review.review_answer !== null
      ? review.review_answer[review.review_answer.length - 1].answer
      : ''
  );

  const [visible, setVisible] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [reserve, setReserve] = useState(0);
  const [memo, setMemo] = React.useState('');

  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Spin spinning={loading}>
        <Content maxWidth={'100%'} padding={10} backgroundColor={'none'}>
          <Row>
            <Col x={24}>
              {/* <Title size={4} style={{ ...styles.title }}>
              리뷰 상세정보
            </Title> */}

              {/* 기본정보 */}
              <Content
                maxWidth={'100%'}
                padding={0}
                borderRadius={4}
                style={{ marginBottom: 20 }}
              >
                {/* ===== 작성자정보 - start ===== */}
                <Title size={5}>작성자정보</Title>
                <Descriptions
                  size="small"
                  bordered
                  column={2}
                  labelStyle={{
                    width: 125,
                    color: '#111',
                    fontWeight: '500',
                    background: '#f4f4f4',
                  }}
                  style={{
                    borderTop: '2px solid #d1d1d1',
                    borderRadius: 5,
                    marginTop: 5,
                  }}
                  items={[
                    /* === Line 1 === */
                    {
                      key: 'user_name_user_account',
                      label: '주문자',
                      children: `${review?.user?.user_name}(${review?.user?.user_account})`,
                    },
                    {
                      key: 'user_phone',
                      label: '수령인 연락처',
                      children: <span>{review?.user?.user_phone}</span>,
                    },

                    /* === Line 2 === */
                    {
                      key: 'recipient_name',
                      label: '성별',
                      children: <span>{review?.user?.user_gender}</span>,
                    },
                    {
                      key: '',
                      label: '',
                      // children: (
                      //   <span>

                      //     {moment(review?.user?.created_at * 1000).format(
                      //       'YYYY-MM-DD(HH:mm)'
                      //     )}
                      //   </span>
                      // ),
                    },

                    /* === Line 3 === */
                    {
                      key: 'user_address',
                      label: '주소',
                      span: 2,
                      children: (
                        <span>
                          [{review.user.postcode}]{review?.user?.user_address}
                          {review?.user?.user_address_detail}
                        </span>
                      ),
                    },
                  ]}
                />
                {/* ===== 작성자정보 - start ===== */}
                <br />

                {/* ===== 상품정보 - start ===== */}
                <Title size={5}>상품정보</Title>
                <Descriptions
                  size="small"
                  bordered
                  column={2}
                  labelStyle={{
                    width: 125,
                    color: '#111',
                    fontWeight: '500',
                    background: '#f4f4f4',
                  }}
                  style={{
                    borderTop: '2px solid #d1d1d1',
                    borderRadius: 5,
                    marginTop: 5,
                  }}
                  items={[
                    /* === Line 1 === */
                    {
                      key: 'product_name',
                      label: '상품명',
                      span: 2,
                      children: <span>{review?.product?.product_name}</span>,
                    },

                    /* === Line 2 === */
                    {
                      key: 'price',
                      label: '단가',
                      children: `${stringToMoneyFormat(
                        review?.product?.price
                      )}원`,
                    },
                    {
                      key: 'product_code',
                      label: '상품코드',
                      children: <span>{review?.product?.product_code}</span>,
                    },

                    /* === Line 3 === */
                    {
                      key: 'packaging_method',
                      label: '포장방식',
                      children: (
                        <span>
                          {
                            PACKAGING_METHOD[review?.product.packaging_method]
                              .title
                          }
                        </span>
                      ),
                    },
                    {
                      key: 'PRODUCT_TYPE',
                      label: '상품유형',
                      children: (
                        <span>{PRODUCT_TYPE[review?.product.type].title}</span>
                      ),
                    },
                  ]}
                />
                {/* ===== 상품정보 - start ===== */}
                <br />

                {/* ===== 리뷰정보 - start ===== */}
                <Title size={5}>리뷰정보</Title>
                <Descriptions
                  size="small"
                  bordered
                  column={2}
                  labelStyle={{
                    width: 125,
                    color: '#111',
                    fontWeight: '500',
                    background: '#f4f4f4',
                  }}
                  style={{
                    borderTop: '2px solid #d1d1d1',
                    borderRadius: 5,
                    marginTop: 5,
                  }}
                  items={[
                    {
                      key: 'Rate',
                      label: '평점',
                      children: (
                        <>
                          <Rate
                            className="rate"
                            size="small"
                            value={review?.review_score}
                            style={{
                              marginRight: 5,
                              letterSpacing: -0.5,
                              margin: 0,
                            }}
                            disabled
                          />
                          <span
                            style={{
                              fontSize: '1.25em',
                              fontWeight: '350',
                            }}
                          >
                            ({review?.review_score}/5)
                          </span>
                        </>
                      ),
                    },
                    {
                      key: 'product_code',
                      label: `노출여부`,
                      children: (
                        <>
                          <Switch
                            defaultChecked={
                              review?.is_show === 'Y' ? true : false
                            }
                            onChange={(e) =>
                              onUpdateReview('is_show', e ? 'Y' : 'N')
                            }
                            checkedChildren="노출"
                            unCheckedChildren="숨김"
                          />
                          &nbsp;
                          {review?.is_show === null && ' (심사전)'}
                        </>
                      ),
                    },

                    /* === Line 3 === */
                    {
                      key: 'review_content',
                      label: '내용',
                      span: 2,
                      children: (
                        <>
                          <div
                            style={{ minHeight: 70 }}
                            dangerouslySetInnerHTML={{
                              __html: review?.review_content,
                            }}
                          ></div>

                          {review?.review_file?.length ? (
                            <Flex gap={8} align="center">
                              <Image.PreviewGroup
                                preview={{
                                  visible: !!visible,
                                  destroyOnClose: true,
                                  onVisibleChange: (v) => setVisible(v),
                                  imageRender: () =>
                                    file?.type === 'VIDEO' ? (
                                      <video
                                        src={`${STORE_URL}/${file?.file_url}`}
                                        width={'80%'}
                                        height={'80%'}
                                        controls
                                        muted
                                        autoPlay
                                      />
                                    ) : (
                                      <Image
                                        src={`${STORE_URL}/${file?.file_url}`}
                                        width={'80%'}
                                        height={'80%'}
                                        preview={false}
                                      />
                                    ),
                                }}
                              ></Image.PreviewGroup>
                              {review?.review_file?.map((file) =>
                                file.type === 'VIDEO' ? (
                                  <video
                                    src={`${STORE_URL}/${file?.file_url}`}
                                    width={'20%'}
                                    height={100}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      setVisible(!visible);
                                      setFile(file);
                                    }}
                                  />
                                ) : (
                                  <Image
                                    src={`${STORE_URL}/${file?.file_url}`}
                                    width={'20%'}
                                    height={100}
                                    style={{
                                      objectFit: 'cover',
                                      cursor: 'pointer',
                                    }}
                                    preview={false}
                                    onClick={() => {
                                      setVisible(!visible);
                                      setFile(file);
                                    }}
                                  />
                                )
                              )}
                            </Flex>
                          ) : null}

                          {review?.review_answer !== null && (
                            <>
                              <Divider style={{ margin: '12px 0' }} />
                              {review?.review_answer.map((item) => (
                                <p>[답변]: {item.answer}</p>
                              ))}
                            </>
                          )}
                        </>
                      ),
                    },
                    {
                      key: 'review_answer',
                      label: '답변',
                      span: 2,
                      children: (
                        <>
                          <Input.TextArea
                            placeholder="답변을 입력해주세요"
                            rows={2}
                            style={{
                              width: 'calc(100% - 85px)',
                              height: 55,
                              marginRight: 3,
                            }}
                            value={answer}
                            onChange={(e) => setAnswer(e.target.value)}
                          />
                          <Button
                            type="primary"
                            style={{ width: 80, height: 55 }}
                            onClick={() =>
                              onUpdateReview('review_answer', answer)
                            }
                          >
                            저장
                          </Button>
                        </>
                      ),
                    },

                    ...(permission === 'ADMIN'
                      ? [
                          {
                            key: 'review_reserve',
                            label: '적립금',
                            span: 2,
                            children: !review?.point_history ? (
                              <>
                                <Flex vertical gap={4}>
                                  <Flex gap={4}>
                                    <InputNumber
                                      placeholder="적립금 입력"
                                      rows={2}
                                      style={{
                                        width: 100,
                                      }}
                                      formatter={(value) =>
                                        `${value}`.replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ','
                                        )
                                      }
                                      min={0}
                                      value={reserve}
                                      onChange={(e) => setReserve(e)}
                                    />
                                    <Button
                                      type="primary"
                                      style={{ width: 80 }}
                                      onClick={() =>
                                        onReserveReview(review, {
                                          reserve: reserve,
                                          memo: memo,
                                        })
                                      }
                                    >
                                      지급
                                    </Button>
                                  </Flex>
                                  <Flex>
                                    <Input.TextArea
                                      placeholder="적립사유"
                                      value={memo}
                                      onChange={(e) => setMemo(e.target.value)}
                                    />
                                  </Flex>
                                </Flex>
                              </>
                            ) : (
                              <>
                                {' '}
                                <InputNumber
                                  placeholder="적립금 입력"
                                  rows={2}
                                  style={{
                                    marginRight: 3,
                                    width: 100,
                                  }}
                                  formatter={(value) =>
                                    `${value}`.replace(
                                      /\B(?=(\d{3})+(?!\d))/g,
                                      ','
                                    )
                                  }
                                  min={0}
                                  value={review?.point_history?.point}
                                  // onChange={(e) => setReserve(e)}
                                  readOnly
                                />
                              </>
                            ),
                          },

                          {
                            key: 'review_content',
                            label: '베스트 리뷰',
                            span: 2,
                            children: (
                              <Switch
                                defaultChecked={
                                  review?.best_review === 'Y' ? true : false
                                }
                                onChange={(e) =>
                                  onUpdateReview('best_review', e ? 'Y' : 'N')
                                }
                                checkedChildren="설정"
                                unCheckedChildren="해제"
                              />
                            ),
                          },
                          {
                            key: 'delete',
                            label: '삭제',
                            span: 2,
                            children: (
                              <>
                                <span style={{ color: '#a7a7a7' }}>
                                  삭제한 데이터는 영구적으로 복구할 수 없으며
                                  작성자에게서도 삭제됩니다.
                                </span>
                                &nbsp;&nbsp;
                                <Button
                                  size="small"
                                  color="danger"
                                  variant="filled"
                                  onClick={() =>
                                    onDeleteReview(review?.review_id)
                                  }
                                >
                                  삭제
                                </Button>
                              </>
                            ),
                          },
                        ]
                      : []),
                  ]}
                />
                {/* ===== 리뷰정보 - start ===== */}

                <br />
                <br />
                {/* <InputFormTable form={form1} /> */}
              </Content>
              {/* 기본정보 끝 */}

              {/* 버튼 */}
              {/* <Content maxWidth={'100%'} backgroundColor={'none'}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button size="large" style={{ ...styles.button }}>
                  취소
                </Button>
                <Button
                  type="primary"
                  size="large"
                  style={{
                    background: 'var(--primary-color)',
                  }}
                >
                  답글 등록
                </Button>
              </div>
            </Content> */}
              {/* 버튼 끝 */}
            </Col>
          </Row>
        </Content>

        {/* 베스트 리뷰 선정 */}
        <ModalLayout
          type={'modal'}
          open={isOpened}
          onCancel={setIsOpened}
          centered
          closable
          title={'베스트리뷰 선정 • 혜택지급'}
          footer={
            <Content
              maxWidth={'100%'}
              padding={0}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <Button onClick={() => setIsOpened(!isOpened)}>닫기</Button>
              <Button type="primary">저장</Button>
            </Content>
          }
        >
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={24}>
                <Content maxWidth={'100%'}>
                  <Text size={13} color={'#BDBDBD'} style={{ marginBottom: 8 }}>
                    선택하신 <span style={{ color: '#0066FF' }}>{'n'}</span>개
                    리뷰에 대해 [베스트리뷰/혜택지급]을 변경합니다.
                  </Text>

                  <InputFormTable
                    form={[
                      {
                        label: '리뷰 글 번호',
                        form: [
                          {
                            input: (
                              <Input.TextArea
                                readOnly
                                disabled
                                style={{ height: 100 }}
                              />
                            ),
                            fullscreen: true,
                          },
                        ],
                      },
                      {
                        label: '베스트리뷰 여부',
                        form: [
                          {
                            input: (
                              <Radio.Group value={'선정'}>
                                <Radio value={'선정'}>선정</Radio>
                                <Radio value={'선정해제'}>선정해제</Radio>
                              </Radio.Group>
                            ),
                          },
                        ],
                      },
                    ]}
                  />
                </Content>
              </Col>

              <Col x={24}>
                <Content maxWidth={'100%'}>
                  <Text size={13} color={'#BDBDBD'} style={{ marginBottom: 8 }}>
                    베스트리뷰 선정 고객에게 지급할 혜택을 선택하세요.
                  </Text>

                  <InputFormTable
                    form={[
                      {
                        label: '혜택',
                        form: [
                          {
                            input: (
                              <Radio.Group value={'혜택 지급하지 않음'}>
                                <Radio value={'혜택 지급하지 않음'}>
                                  혜택 지급하지 않음
                                </Radio>
                                <Radio value={'쿠폰'}>쿠폰</Radio>
                                <Radio value={'포인트적립'}>포인트적립</Radio>
                              </Radio.Group>
                            ),
                          },
                        ],
                      },
                    ]}
                  />
                </Content>
              </Col>

              <Col x={24}>
                <Content maxWidth={'100%'}>
                  <Text size={13} color={'#0066FF'}>
                    • 의료기기에 작성된 리뷰는 베스트리뷰로 선정하지 않도록
                    유의해주세요. (의료기기법에 근거함)
                  </Text>
                  <Text size={13} color={'#0066FF'}>
                    • 베스트리뷰로 선정하신 리뷰가 관리자에 의해 비노출처리 될
                    경우 지급하신 포인트 혜택은 자동 회수됩니다. (단, 쿠폰은
                    회수되지 않습니다.)
                  </Text>
                  <Text size={13} color={'#0066FF'}>
                    • 동일한 리뷰로 중복 선정된 고객은 지급 대상에서 제외됩니다.
                  </Text>
                </Content>
              </Col>
            </Row>
          </Content>
        </ModalLayout>
      </Spin>
    </>
  );
};

const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
  button: {
    width: 80,
    height: 40,
    fontSize: 15,
    fontWeight: 600,
    margin: '0px 4px',
  },
  form: {
    input: {
      large: {
        width: 175,
        marginRight: 8,
      },
      medium: {
        width: 100,
        marginRight: 8,
      },
    },
    button: {
      marginRight: 8,
    },
    date: {
      width: 120,
    },
    text: {
      fontSize: 13,
      fontWeight: 400,
    },
  },
};

export default ReviewDetailPresenter;
